import { render, staticRenderFns } from "./blanks.vue?vue&type=template&id=76aa1074&scoped=true&"
import script from "./blanks.vue?vue&type=script&lang=js&"
export * from "./blanks.vue?vue&type=script&lang=js&"
import style0 from "./blanks.vue?vue&type=style&index=0&id=76aa1074&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aa1074",
  null
  
)

export default component.exports